import {
  createRouter,
  createWebHistory,
  type RouteLocationNormalized,
} from "vue-router";

import { useAuthStore } from "./stores/auth";

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("./views/LoginView.vue"),
      meta: { requiresGuest: true },
    },
    {
      path: "/",
      component: () => import("./components/AppShell.vue"),
      meta: { requiresAuth: true },
      children: [
        { path: "", name: "home", component: () => import("./views/HomeView.vue") },
        { path: "chat", name: "chat", component: () => import("./views/ChatView.vue") },
        { path: "wiki", name: "wiki-home", component: () => import("./views/WikiHomeView.vue") },
        {
          path: "wiki/pages/:id",
          name: "wiki-page",
          component: () => import("./views/WikiPageView.vue"),
        },
        {
          path: "wiki/pages/:id/edit",
          name: "wiki-page-edit",
          component: () => import("./views/WikiPageEditView.vue"),
        },
        {
          path: "wiki/pages/:id/history",
          name: "wiki-page-history",
          component: () => import("./views/WikiHistoryView.vue"),
        },
        { path: "bookmarks", name: "bookmarks", component: () => import("./views/BookmarksView.vue") },
        { path: "dm", name: "dm", component: () => import("./views/DMView.vue") },
        { path: "search", name: "search", component: () => import("./views/SearchView.vue") },
        { path: "mentions", name: "mentions", component: () => import("./views/MentionsView.vue") },
        { path: "tasks", name: "tasks", component: () => import("./views/TasksView.vue") },
        { path: "todo", name: "todo", component: () => import("./views/TodoView.vue") },
        { path: "calendar", name: "calendar", component: () => import("./views/CalendarView.vue") },
        { path: "settings", name: "settings", component: () => import("./views/SettingsView.vue") },
        { path: "help", name: "help", component: () => import("./views/HelpView.vue") },
        { path: "shops", name: "shops", component: () => import("./views/ShopsView.vue") },
        { path: "shops/candidates", name: "shop-candidates", component: () => import("./views/ShopCandidatesView.vue") },
        { path: "shops/share", name: "shop-share", component: () => import("./views/ShopShareView.vue") },
        { path: "bookmarks/share", name: "bookmark-share", component: () => import("./views/BookmarkShareView.vue") },
        { path: "shops/:id", name: "shop-detail", component: () => import("./views/ShopDetailView.vue") },
        {
          path: "admin/users",
          name: "admin-users",
          component: () => import("./views/AdminUsersView.vue"),
          meta: { requiresAdmin: true },
        },
        {
          path: "admin/channels",
          name: "admin-channels",
          component: () => import("./views/AdminChannelsView.vue"),
          meta: { requiresAdmin: true },
        },
        {
          path: "admin/ml",
          name: "admin-ml",
          component: () => import("./views/AdminMLView.vue"),
          meta: { requiresAdmin: true },
        },
        {
          path: "admin/settings",
          name: "admin-settings",
          component: () => import("./views/AdminSettingsView.vue"),
          meta: { requiresAdmin: true },
        },
        {
          path: "admin/audit",
          name: "admin-audit",
          component: () => import("./views/AdminAuditView.vue"),
          meta: { requiresAdmin: true },
        },
        {
          path: "admin/roles",
          name: "admin-roles",
          component: () => import("./views/AdminRolesView.vue"),
          meta: { requiresAdmin: true },
        },
        {
          path: "admin/cuisines",
          name: "admin-cuisines",
          component: () => import("./views/AdminCuisinesView.vue"),
          meta: { requiresAdmin: true },
        },
      ],
    },
    {
      path: "/:pathMatch(.*)*",
      name: "not-found",
      component: () => import("./views/NotFoundView.vue"),
    },
  ],
});

router.beforeEach(async (to: RouteLocationNormalized) => {
  const auth = useAuthStore();
  // 起動直後の初回ナビゲーションは restore() の完了を待ってから判定する。
  // (vue-router 4 は app.use(router) 直後に初回ナビを開始するため、
  //  await しないと user 未復元のまま guard が走り login に飛ばされる)
  await auth.ready();
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: "login", query: { redirect: to.fullPath } };
  }
  if (to.meta.requiresGuest && auth.isAuthenticated) {
    return { name: "home" };
  }
  if (to.meta.requiresAdmin && !auth.isAdmin) {
    return { name: "home" };
  }
});
